import React from "react";
import { Briefcase, Layers, Tag, Package, Hash, Database, Info, FileText, CheckCircle2 } from "lucide-react";
import { FormInput, FormSelect, SearchableSelect, FormTextarea } from "./SharedFormComponents";

export const ItemForm = ({ form, errors, handleInputChange, dropdowns }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 animate-in fade-in slide-in-from-bottom-2 duration-300">
      <SearchableSelect
        icon={<Briefcase size={14} />}
        label="Item Type"
        required
        field="itemType"
        options={[
          { value: "Product", label: "Product" },
          { value: "Service", label: "Service" },
          { value: "Material", label: "Material" },
        ]}
        value={form.itemType}
        onChange={handleInputChange}
        error={errors.itemType}
        placeholder="Select Type"
      />
      <SearchableSelect
        icon={<Layers size={14} />}
        label="Category"
        required
        field="category"
        options={dropdowns.categories.map((c) => ({
          value: c._id,
          label: c.label,
        }))}
        value={form.category}
        onChange={handleInputChange}
        error={errors.category}
        placeholder="Select Category"
      />
      <SearchableSelect
        icon={<Tag size={14} />}
        label="Brand"
        required
        field="brand"
        options={dropdowns.brands.map((b) => ({
          value: b._id,
          label: b.label,
        }))}
        value={form.brand}
        onChange={handleInputChange}
        error={errors.brand}
        placeholder="Select Brand"
      />
      <FormInput
        icon={<Package size={14} />}
        label="Item Name"
        required
        field="itemName"
        value={form.itemName}
        onChange={handleInputChange}
        error={errors.itemName}
        placeholder="e.g. Plywood 18mm"
      />
      <FormInput
        icon={<Hash size={14} />}
        label="Item Code"
        required
        field="itemCode"
        value={form.itemCode}
        onChange={handleInputChange}
        error={errors.itemCode}
        placeholder="P001"
      />
      <FormInput
        icon={<Hash size={14} />}
        label="HSN/SAC Code"
        field="hsnSacCode"
        value={form.hsnSacCode}
        onChange={handleInputChange}
        placeholder="4412"
      />
      <FormInput
        icon={<Hash size={14} />}
        label="Barcode"
        field="barcode"
        value={form.barcode}
        onChange={handleInputChange}
        placeholder="Scan or enter barcode"
      />
      <SearchableSelect
        icon={<Database size={14} />}
        label="Units"
        required
        field="units"
        options={dropdowns.units.map((u) => ({ value: u._id, label: u.label }))}
        value={form.units}
        onChange={handleInputChange}
        error={errors.units}
        placeholder="Select Unit"
      />
      <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormSelect
          icon={<CheckCircle2 size={14} />}
          label="Status"
          required
          field="status"
          options={[
            { value: "ACTIVE", label: "Active" },
            { value: "INACTIVE", label: "Inactive" },
          ]}
          value={form.status || "ACTIVE"}
          onChange={handleInputChange}
          error={errors.status}
        />
        
        <div className="p-4 rounded-xl border border-slate-100/50 space-y-3">
          <div className="flex items-center gap-3">
            <input
              type="checkbox"
              id="isUnique"
              name="isUnique"
              className="w-4 h-4 text-brand-blue border-slate-300 rounded focus:ring-brand-blue transition-all cursor-pointer"
              checked={form.isUnique || false}
              onChange={handleInputChange}
            />
            <label
              htmlFor="isUnique"
              className="text-xs font-bold text-slate-500 uppercase tracking-widest cursor-pointer"
            >
              Serial / Unique Managed
            </label>
          </div>
          <div className="flex items-center gap-3">
            <input
              type="checkbox"
              id="isBatchExpiry"
              name="isBatchExpiry"
              className="w-4 h-4 text-brand-blue border-slate-300 rounded focus:ring-brand-blue transition-all cursor-pointer"
              checked={form.isBatchExpiry || false}
              onChange={handleInputChange}
            />
            <label
              htmlFor="isBatchExpiry"
              className="text-xs font-bold text-slate-500 uppercase tracking-widest cursor-pointer"
            >
              Has Batch / Expiry
            </label>
          </div>
        </div>
      </div>

      {form.isUnique && (
        <div className="md:col-span-2">
          <FormInput
            icon={<Info size={14} />}
            label="Unique Identifier Name"
            required
            field="uniqueName"
            value={form.uniqueName}
            onChange={handleInputChange}
            error={errors.uniqueName}
            placeholder="e.g. Serial Number, Chassis No"
          />
        </div>
      )}

      <div className="md:col-span-2">
        <FormTextarea
          icon={<FileText size={14} />}
          label="Description"
          field="description"
          value={form.description}
          onChange={handleInputChange}
          placeholder="Enter technical specifications..."
        />
      </div>
    </div>
  );
};
